import { Navigate } from "react-router-dom";
import { getAccessTokenFromLocalStorage } from "../../Helpers/jwtUtility";

const onRequest = (request) => {
  const token = getAccessTokenFromLocalStorage();
  request.headers["Authorization"] = token;
  return request;
};

const onRequestError = (error) => {
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = (error) => {
  console.log(error.response?.data);
  if (error.response?.data?.message === "Session expired") {
    <Navigate to={"/logout"} />;
  }

  return Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance) {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
